module.exports = __webpack_public_path__ + "static/media/dettlaff.9344e4ff.png";